#import "../../../../power-ai/timeline-summary/graphql/fragments/entity-summary-fragment.graphql"

query GetLeadContextSummary($id: ID!) {
    leadContextSummary(id: $id) {
        ...EntitySummaryFragment
    }
}
